


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProcessNumberBase extends Vue {
   private openpen = false;
   @Prop(Array) public workProcss!: any;
}
